import React, { useState} from 'react';
import ListaInv from './ListaInv';
import './ListaInv.css';

function VerListaInv() {
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    window.addEventListener("orientationchange", function(){
      window.location.reload();
    });
  return (
    <ListaInv/>
  )
}

export default VerListaInv